<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="preload" active>
      <a-form :form="form" @submit="handleSubmit">

        <a-divider dashed orientation="left">Biller Information</a-divider>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: layout.wrapper }" label="Name">
          <a-input placeholder="Biller Name" v-decorator="[ 'name', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Contact Name">
          <a-input placeholder="Contact Name" v-decorator="[ 'contact_name', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{span: layout.label}" :wrapper-col="{ span: 7 }" label="Contact Email">
          <a-input placeholder="Contact Email" type="email" v-decorator="[ 'contact_email', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Contact Phone">
          <a-input placeholder="Contact Phone" v-decorator="[ 'contact_phone', { rules: [ { required: true } ] } ]">
            <a-icon slot="prefix" type="phone" style="color: rgba(0,0,0,0.25)"/>
          </a-input>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: layout.label}">
          <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit</a-button>
        </a-form-item>
      </a-form>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  props: {
    layout: {
      type: Object,
      default: function () {
        return {
          label: 4,
          wrapper: 8
        }
      }
    },
    biller: {
      type: String,
      default: ''
    }
  },
  computed: {
    editing() {
      return this.biller !== ''
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      preload: false,
      processing: false,
      item: {}
    }
  },
  created() {
    if (this.editing) {
      this.preload = true
      this.getItem()
    }
  },
  methods: {
    getItem() {
      this.$http.get(this.routeUri('hyperion.biller.show', { biller_hash: this.biller }))
        .then(res => (this.item = res.data))
        .finally(() => this.preload = false)
    },
    handleSubmit(e) {
      e.preventDefault(e)

      this.form.validateFields((err, formData) => {
        if (!err) {
          this.processing = true

          let promise

          if (this.editing) {
            promise = this.$http.put(this.routeUri('hyperion.biller.update', { biller_hash: this.biller }), formData)
          } else {
            promise = this.$http.post(this.routeUri('hyperion.client.store'), formData)
          }

          promise.then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleResponseError(error.response.data.data))
            .finally(() => this.processing = false)
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Saved!',
        description: 'Data has been successfully saved!'
      })
      setTimeout(() => window.location.href = data.redirect, 2000)
    },
    handleResponseError(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    }
  },
  watch: {
    item: function (value) {
      this.form.getFieldDecorator('name', {initialValue: value.name})
      this.form.getFieldDecorator('contact_name', {initialValue: value.contact_name})
      this.form.getFieldDecorator('contact_email', {initialValue: value.contact_email})
      this.form.getFieldDecorator('contact_phone', {initialValue: value.contact_phone})
    }
  }
}
</script>
